export const tileChromeClassName = 'tile-chrome';
